// extracted by mini-css-extract-plugin
export default {"main-nav":"Navigations_main-nav__o1N+B","active":"Navigations_active__HIV8u","footer-nav":"Navigations_footer-nav__KCoaz"};